import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportIssueResponse, ReportIssueModel } from './report-issue.model';

@Injectable({
  providedIn: 'root'
})

export class ReportIssueService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string,
  ) { }

  public reportIssue(issue: ReportIssueModel): Observable<ReportIssueResponse> {
    return this.http.post<any>(this.apiUrl + 'ReportIssue/report-issue', issue);
  }
}
